import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next'; // ✅ Ավելացված է
import { API_BASE } from './apiConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faClock, faBullhorn, faBoxOpen } from '@fortawesome/free-solid-svg-icons';

const Notifications = ({ user, refreshUnreadCount }) => {
    const { t, i18n } = useTranslation(); // ✅ i18n հուկ
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('token');

        if (user?.id && token) {
            const fetchAllData = async () => {
                try {
                    const headers = { 
                        'ngrok-skip-browser-warning': 'true',
                        'Authorization': `Bearer ${token}` 
                    };
                    
                    const [ordersRes, notifsRes] = await Promise.all([
                        axios.get(`${API_BASE}/api/user-orders/${user.id}`, { headers }),
                        axios.get(`${API_BASE}/api/notifications/${user.id}`, { headers })
                    ]);

                    const combined = [
                        ...(ordersRes.data || []).map(item => ({ ...item, type: 'order' })),
                        ...(notifsRes.data || []).map(item => ({ ...item, type: 'admin' }))
                    ];

                    combined.sort((a, b) => new Date(b.created_at || b.updated_at) - new Date(a.created_at || a.updated_at));

                    setNotifications(combined);
                    setLoading(false);

                    const unreadAdminNotifs = (notifsRes.data || []).filter(n => Number(n.is_read) === 0);
                    
                    if (unreadAdminNotifs.length > 0) {
                        await axios.put(`${API_BASE}/api/notifications/mark-as-read/${user.id}`, {}, { headers });
                        if (refreshUnreadCount) refreshUnreadCount();
                    }

                } catch (err) {
                    console.error("❌ Notifications Error:", err.message);
                    setLoading(false);
                }
            };

            fetchAllData();
        } else {
            setLoading(false);
        }
    }, [user?.id, refreshUnreadCount]);

    if (!user) return (
        <div style={{padding: '120px 20px', textAlign: 'center'}}>
            {t('login_subtitle')} {/* Օգտագործում ենք "Մուտք գործեք" բանալին */}
        </div>
    );

    return (
        <div style={{ padding: '120px 20px', maxWidth: '700px', margin: '0 auto', minHeight: '80vh' }}>
            <h2 style={{ marginBottom: '30px', display: 'flex', alignItems: 'center', gap: '12px', color: '#1e293b' }}>
                <FontAwesomeIcon icon={faBell} color="#c5a059" /> {t('admin_notifications')}
            </h2>

            {loading ? (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <p style={{ color: '#c5a059', fontWeight: 'bold' }}>{t('login_btn_loading')}</p>
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                    {notifications.length === 0 ? (
                        <p style={{ textAlign: 'center', color: '#64748b' }}>{t('contact_no_messages')}</p>
                    ) : (
                        notifications.map((n, idx) => {
                            const isRead = n.type === 'order' ? true : Number(n.is_read) === 1;

                            return (
                                <div key={`${n.type}-${n.id || idx}`} style={{
                                    padding: '20px',
                                    borderRadius: '15px',
                                    background: isRead ? '#fff' : 'rgba(197, 160, 89, 0.05)',
                                    border: `1px solid ${isRead ? '#e2e8f0' : '#c5a059'}`,
                                    boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)',
                                    position: 'relative',
                                    transition: '0.3s'
                                }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                        <span style={{ 
                                            fontSize: '11px', 
                                            padding: '5px 10px', 
                                            borderRadius: '20px', 
                                            background: n.type === 'order' ? '#f1f5f9' : '#fffbeb',
                                            color: n.type === 'order' ? '#475569' : '#b45309',
                                            fontWeight: '800',
                                            textTransform: 'uppercase'
                                        }}>
                                            <FontAwesomeIcon icon={n.type === 'order' ? faBoxOpen : faBullhorn} style={{marginRight: '5px'}} />
                                            {n.type === 'order' ? t('nav_orders') : t('admin_notifications')}
                                        </span>
                                        <span style={{ fontSize: '11px', color: '#94a3b8' }}>
                                            <FontAwesomeIcon icon={faClock} style={{marginRight: '5px'}} /> 
                                            {new Date(n.created_at || n.updated_at).toLocaleString(
                                                i18n.language === 'hy' ? 'hy-AM' : i18n.language === 'ru' ? 'ru-RU' : 'en-US'
                                            )}
                                        </span>
                                    </div>

                                    {n.type === 'order' ? (
                                        <div>
                                            <h4 style={{ margin: '0 0 5px 0', color: '#1e293b' }}>{n.service_name}</h4>
                                            <p style={{ margin: 0, color: '#c5a059', fontWeight: '700' }}>
                                                {/* Կարգավիճակի դինամիկ թարգմանություն */}
                                                {t('status_label', { defaultValue: 'Status' })}: {t(`status_${n.status}`) || n.status}
                                            </p>
                                        </div>
                                    ) : (
                                        <p style={{ margin: 0, color: '#334155', lineHeight: '1.6', fontWeight: isRead ? '400' : '600' }}>
                                            {n.message}
                                        </p>
                                    )}
                                </div>
                            );
                        })
                    )}
                </div>
            )}
        </div>
    );
};

export default Notifications;